module.exports = __webpack_public_path__ + "files/8075d14aa49687aad5e147668cc3402a.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_SansSerif-Regular.ttf
// module id = 1436
// module chunks = 59